import { Box, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {SensorType, TypeSensor } from "../../pages/camaras/interface/camara.interface";
import moment from "moment";
import { usePageVisibility } from "../../pages/camaras/usePageVisibility";
import Tooltip from '@mui/material/Tooltip';

import Vent1 from "./images/Vent_Cond_1.jpg";
import Vent2 from "./images/Vent_Cond_2.jpg";

import Succion_OFF from "./images/Succion_Apagada.jpg";
import Succion_ON from "./images/Succion_ON.jpg";

import Liquido_OFF from "./images/Liquido_Apagada.jpg";
import Liquido_ON from "./images/Liquido_ON.jpg";

import Deshielo_OFF from "./images/Gas_Caliente_Apagada.jpg";
import Deshielo_ON from "./images/Gas_Caliente_ON.jpg";

import Bomba1 from "./images/Bomba_Agua_1_Rot.jpg";
import Bomba2 from "./images/Bomba_Agua_2_Rot.jpg";
import Bomba3 from "./images/Bomba_Agua_3_Rot.jpg";
import Bomba4 from "./images/Bomba_Agua_4_Rot.jpg";

import Comp1 from "./images/Comp_1.jpg";
import Comp2 from "./images/Comp_2.jpg";
import Comp3 from "./images/Comp_3.jpg";

import Tornillo0 from "./images/Tornillo_Apagado.jpg";
import Tornillo1 from "./images/Tornillo_Marcha_1.jpg";
import Tornillo2 from "./images/Tornillo_Marcha_2.jpg";
import Tornillo3 from "./images/Tornillo_Marcha_3.jpg";



type CardProps = {
    propsSensorEstado: TypeSensor;
}


const frames_Ventilador = [Vent1, Vent2];
const frames_Succion = [Succion_OFF, Succion_ON];
const frames_Liquido = [Liquido_OFF, Liquido_ON];
const frames_Deshielo = [Deshielo_OFF, Deshielo_ON];
const frames_Bomba = [Bomba1, Bomba2, Bomba3, Bomba4];
const frames_Compresor = [Comp1, Comp2, Comp3];
const frames_Tornillo = [Tornillo0, Tornillo1, Tornillo2, Tornillo3];

/*const frames = [
  "public/images/Vent_Cond_1.jpg",
  "public/images/Vent_Cond_2.jpg",
 "/images/fan3.jpg",
  "/images/fan4.jpg",
];*/

export const EstadoComponent: React.FC<CardProps> = ({propsSensorEstado}) => {

    const isPageVisible = usePageVisibility();
    const timerIdRef = React.useRef<NodeJS.Timer | null>(null); 

    const [estado, setEstado] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (moment().diff(propsSensorEstado.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
            setEstado(false);
        else
            setEstado(true);


        const controllingCallback = () => {
            if (moment().diff(propsSensorEstado.valores[0].fecha_hora_value, 'minute') > 5) //Controla que se actualizen los valores
                setEstado(false);
            else
                setEstado(true);
        };

        const startPolling = () => {
            timerIdRef.current = setInterval(controllingCallback, 60000); //Cada 1 minuto
        };

        const stopPolling = () => {
            clearInterval(timerIdRef.current!);
        };

        if (isPageVisible) {
            startPolling();
        } else {
            stopPolling();
        }

        return () => {
            stopPolling();
        };

    }, [propsSensorEstado,  isPageVisible]);

    const [frameVentiladorIndex, setFrameVentiladorIndex] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (propsSensorEstado.valores[0].value === '1' && 
            propsSensorEstado.tipo_sensor === SensorType.ESTADO_VENTILADORES &&
            estado) {
            interval = setInterval(() => {
                setFrameVentiladorIndex((prev) => (prev + 1) % frames_Ventilador.length);
            }, 200);
        }

        return () => {
        if (interval) clearInterval(interval);
        };
    }, [propsSensorEstado, estado]);

    const [frameBombaIndex, setFrameBombaIndex] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (propsSensorEstado.valores[0].value === '1' && 
            propsSensorEstado.tipo_sensor === SensorType.ESTADO_BOMBA &&
            estado) {
            interval = setInterval(() => {
                setFrameBombaIndex((prev) => (prev + 1) % frames_Bomba.length);
            }, 200);
        }

        return () => {
        if (interval) clearInterval(interval);
        };
    }, [propsSensorEstado, estado]);

    const [frameCompresorIndex, setFrameCompresorIndex] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (propsSensorEstado.valores[0].value === '1' && 
            propsSensorEstado.tipo_sensor === SensorType.ESTADO_COMPRESOR &&
            estado) {
            interval = setInterval(() => {
                setFrameCompresorIndex((prev) => (prev + 1) % frames_Compresor.length);
            }, 200);
        }

        return () => {
        if (interval) clearInterval(interval);
        };
    }, [propsSensorEstado, estado]);    

    const [frameTornilloIndex, setFrameTornilloIndex] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if( propsSensorEstado.tipo_sensor === SensorType.ESTADO_TORNILLO &&
            estado)
        {

            if (propsSensorEstado.valores[0].value === '1') {
                interval = setInterval(() => {
                    setFrameTornilloIndex((prev) => (prev + 1) % frames_Tornillo.length);
                }, 200);
            }

            if (propsSensorEstado.valores[0].value === '0') {
                    setFrameTornilloIndex(0);
            }
        }

        return () => {
        if (interval) clearInterval(interval);
        };
    }, [propsSensorEstado, estado]);




    const getTipoEstado = (sensor:TypeSensor) => {
        
        switch (sensor.tipo_sensor) {
            case SensorType.ESTADO_VENTILADORES:
                return  <Box
                            component="img"
                            src={frames_Ventilador[frameVentiladorIndex]}
                            alt="animacion"
                            sx={{ width: "50%", height: "50%", objectFit: "cover" }}
                            mb ={1}
                        />;
            case SensorType.ESTADO_SOL_ASPIRACION:
                return  <Box
                            component="img"
                            src={(propsSensorEstado.valores[0].value === '1') ? frames_Succion[1] : frames_Succion[0]}
                            alt="animacion"
                            sx={{ width: "50%", height: "50%", objectFit: "cover" }}
                            mb ={1}
                        />;
            case SensorType.ESTADO_SOL_LIQUIDO:
                return  <Box
                            component="img"
                            src={(propsSensorEstado.valores[0].value === '1') ? frames_Liquido[1] : frames_Liquido[0]}
                            alt="animacion"
                            sx={{ width: "50%", height: "50%", objectFit: "cover" }}
                            mb ={1}
                        />;
            case SensorType.ESTADO_SOL_DESHIELO:
                return  <Box
                            component="img"
                            src={(propsSensorEstado.valores[0].value === '1') ? frames_Deshielo[1] : frames_Deshielo[0]}
                            alt="animacion"
                            sx={{ width: "50%", height: "50 %", objectFit: "cover" }}
                            mb ={1}
                        />;                        
            case SensorType.ESTADO_BOMBA:
                return  <Box
                            component="img"
                            src={frames_Bomba[frameBombaIndex]}
                            alt="animacion"
                            sx={{ width: "70%", height: "50%", objectFit: "cover" }}
                            mb ={1}
                        />;
            case SensorType.ESTADO_COMPRESOR:
                return  <Box
                            component="img"
                            src={frames_Compresor[frameCompresorIndex]}
                            alt="animacion"
                            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                            mb ={1}
                        />;
            case SensorType.ESTADO_TORNILLO:
                return  <Box
                            component="img"
                            src={frames_Tornillo[frameTornilloIndex]}
                            alt="animacion"
                            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                            mb ={1}
                        />;
            default:
                return <></>;
        }    
    }



    return (
        <Paper
            elevation={3} // profundidad
            sx={{
                minwidth: 50,
                minheight: 50,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                p: 1,
                backgroundColor: "#f5f5f5",
            }}
        >
            {(propsSensorEstado.valores?.length !== 0 && estado)?(
                <>
                    {/* Título */}
                    <Typography                         
                        variant = "caption" 
                        align="center"
                        >
                        {propsSensorEstado.name_front}
                    </Typography>
                    {/* Imagen o Animacion */}
                    {getTipoEstado(propsSensorEstado)}
                    {/* Estado ON/OFF*/}
                    <Tooltip 
                        title={`Ultima muestra: ${moment(propsSensorEstado.valores[0].fecha_hora_value).format("DD/MM/YYYY HH:mm")}
                        Descirpcion: ${propsSensorEstado.descripcion} `} 
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                whiteSpace: "normal", // permite que se divida en varias líneas
                                wordWrap: "break-word",
                                textAlign: "center",
                                minWidth: "50px",
                                backgroundColor: (propsSensorEstado.valores[0].value === '1') ? 'green' : '#D3D3D3',
                                color: (propsSensorEstado.valores[0].value === '1') ? 'white': 'black',
                            }}
                        >
                            {(propsSensorEstado.valores[0].value === '1') ? 'ON': 'OFF'}
                        </Typography>
                    </Tooltip>
                </>) : (" ")
            }
        </Paper>            
    )
}

